import instantiate from './Instantiate';
export default instantiate;
